import Vue from "vue"
import {
  errorImg
} from './img64.js'
import {
  MessageBox,
  Message,
  Loading
} from 'element-ui'
/* 时间戳转时间 */
Date.prototype.format = function(fmt) {
  var o = {
    'Y+': this.getFullYear(),
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds()
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ?
        o[k] < 10 ?
        '0' + o[k] :
        o[k] :
        ('00' + o[k]).substr(('' + o[k]).length)
      );
  }
  return fmt;
};

/**
 * 数字转中文大写
 */
function moneyUpperCase() {
  let money = Number(this);
  var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
  var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
  var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
  var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
  var cnInteger = "整"; //整数金额时后面跟的字符
  var cnIntLast = "元"; //整型完以后的单位
  var maxNum = 999999999999999.9999; //最大处理的数字
  var IntegerNum; //金额整数部分
  var DecimalNum; //金额小数部分
  var ChineseStr = ""; //输出的中文金额字符串
  var parts; //分离金额后用的数组，预定义
  var Symbol = ""; //正负值标记
  if (money == "" || isNaN(money)) {
    return "";
  }
  money = parseFloat(money).toFixed(2) * 1;
  if (money >= maxNum) {
    // alert('超出最大处理数字');
    return "";
  }
  if (money == 0) {
    ChineseStr = cnNums[0] + cnIntLast + cnInteger;
    return ChineseStr;
  }
  if (money < 0) {
    money = -money;
    Symbol = "负 ";
  }
  money = money.toString(); //转换为字符串
  if (money.indexOf(".") == -1) {
    IntegerNum = money;
    DecimalNum = '';
  } else {
    parts = money.split(".");
    IntegerNum = parts[0];
    DecimalNum = parts[1].substr(0, 4);
  }
  if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
    var zeroCount = 0;
    var IntLen = IntegerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = IntegerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == "0") {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          ChineseStr += cnNums[0];
        }
        zeroCount = 0; //归零
        ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        ChineseStr += cnIntUnits[q];
      }
    }
    ChineseStr += cnIntLast;
    //整型部分处理完毕
  }
  if (DecimalNum != '') { //小数部分
    var decLen = DecimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = DecimalNum.substr(i, 1);
      if (n != '0') {
        ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (ChineseStr == '') {
    ChineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (DecimalNum == '') {
    ChineseStr += cnInteger;
  }
  ChineseStr = Symbol + ChineseStr;
  return ChineseStr;
}

String.prototype.moneyUpperCase = moneyUpperCase; //金额大写
Number.prototype.moneyUpperCase = moneyUpperCase; //金额大写

/**
 * toFixed精度处理
 */
Number.prototype.toFixedOld = Number.prototype.toFixed;
Number.prototype.toFixed = function(num) { //解决toFixed处理精度问题
  return (Math.round((this * Math.pow(10, num)).toFixedOld(2)) / Math.pow(10, num)).toFixedOld((num <= 0 ? 0 : num))
}
String.prototype.toFixed = function(num) {
  if (!isNaN(this)) {
    return (this * 1).toFixed(2)
  }
  return this
}

/**
 * JSON 数据深拷贝
 */
Vue.prototype.copyData = function(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 时间范围处理
 * @param {Array} range [开始时间，结束时间]
 * @param {Number} day 范围天数
 * @param {String} format 范围时间格式
 */
Vue.prototype.daterange = function(range, day = 31, format = 'Y-M-d') {
  let _in = true; //是否在时间范围内
  if (range) {
    let start_time = new Date(range[0]).getTime();
    let end_time = new Date(range[1]).getTime();
    let day_time = day * 24 * 60 * 60 * 1000;
    if (end_time - start_time > day_time) {
      _in = false;
      range[0] = new Date(end_time - day_time).format(format);
    }
  }
  return {
    range,
    _in
  }
}

/**
 * sessionStorage 缓存处理
 */
Vue.prototype.getSession = function(key) {
  let values = sessionStorage.getItem(key);
  if (values === undefined) {
    return "";
  }
  try {
    return JSON.parse(values, null);
  } catch (e) {
    return values;
  }
}
Vue.prototype.setSession = function(key, data) {
  if (typeof data == "string" || data instanceof String) {
    window.sessionStorage.setItem(key, data);
    return;
  }
  try {
    window.sessionStorage.setItem(key, JSON.stringify(data));
  } catch (e) {}
}
Vue.prototype.removeSession = function(key) {
  sessionStorage.removeItem(key)
}

/**
 * localStorage 缓存处理
 */
Vue.prototype.getLocal = function(key) {
  let values = localStorage.getItem(key);
  if (values === undefined) {
    return "";
  }
  try {
    return JSON.parse(values, null);
  } catch (e) {
    return values;
  }
}
Vue.prototype.setLocal = function(key, data) {
  if (typeof data == "string") {
    window.localStorage.setItem(key, data);
    return;
  }
  try {
    window.localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {}
}
Vue.prototype.removeLocal = function(key) {
  localStorage.removeItem(key)
}

/**
 * 输入框限制数字小数点位数
 */
Vue.prototype.setNumber = function(val, type, num = 2) {
  //  "\^\\D*((-{1}|'')\\d*(\?:"+(num>0?"\\.\\d{0,2}":"")+")\?).*\$"
  let reg = '';
  let value = '';
  if (val) {
    if (type && val.indexOf('-') >= 0) {
      reg = new RegExp("\^\\D*(-{1}\\d*(\?:" + (num > 0 ? "\\.\\d{0,2}" : "") + ")\?).*\$", "g")
    } else {
      reg = new RegExp("\^\\D*(\\d*(\?:" + (num > 0 ? "\\.\\d{0,2}" : "") + ")\?).*\$", "g")
    }
    value = val.replace(reg, '$1');
  } else {
    value = '';
  }
  return value
}

/**
 * oss图片处理 全局过滤器注册
 */
function setImage(img, w = 150) {
  if (!img) return errorImg;
  if (img.indexOf('/static/') == 0 || img.indexOf('erp.douhuomall.com/img.php')>0) {
    return img
  } else if (img.indexOf('http') == -1) {
    if (process.env.NODE_ENV === 'development') {
      return `http://wtest.douhuomall.com${img}`
      // http://t1.douhuomall.com https://www.douhuomall.com
    }
    return Vue.prototype.location.origin + img
  } else if(w){
    let arr = img.split('?');
    return arr[0] + '?x-oss-process=image/format,webp/resize,w_' + w
  }
  return img;
}
Vue.filter('setImage', setImage)
Vue.prototype.setImage = setImage

/**
 * router 跳转处理
 */
Vue.prototype.location = window.location

Vue.prototype.navTo = function(path, query = {}, open = false,is_name=true) {
  if (path) {
    if (!open) {
      if(path===this.$route.path){
        let that = this.$route.matched[1].instances.default;
        that.init&that.init(query)
      }
      this.$bus.$emit('scrollTop')
      if(is_name){
        let name = path.replace('/', '')
        this.$router.push({
          name,
          params: query
        })
      }else{
        this.$router.push({
          path,
          query
        })
      }
    } else {
      if (path.indexOf('http') != 0) {
        let rpath = path;
        if (query == 1) {
          rpath = '/#' + path
        } else if (query) {
          let routerPath = this.$router.resolve({
            path,
            query
          })
          rpath = '/' + routerPath.href
        }
        window.open(`${this.location.origin+rpath}`, '_blank')
      } else {
        window.open(path, '_blank')
      }
    }
  }
}
Vue.prototype.navBack = function() {
  this.$router.go(-1)
}

Vue.prototype.checkLogin = function() {
  if(this.$store.state.sysInfo.is_tourist){
    MessageBox.confirm('您还未登录，立即去登录吧?', '提示', {
      confirmButtonText: '去登录',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      window.open(`/manager/index/index`, '_blank')
    })
    return false;
  }
  return true;
}

Vue.prototype.toLoginRise = function() {
    MessageBox.confirm(this.$store.state.sysInfo.sys_id==11?'您还未登录，立即去登录吧?':'您未达到要求，立即去升级吧！', '提示', {
      confirmButtonText: this.$store.state.sysInfo.sys_id==11?'去登录':'去升级',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      window.open(this.$store.state.sysInfo.sys_id==11?'/manager/login/index':'/manager/index/comboList', '_blank')
    })
}
Vue.prototype.selectNav = function(item={}) {
    if(this.$store.state.sysInfo.combo_id==2&&item!='index'&&!item.click){
      return this.toLoginRise()
    }
    if(item.is_auth===0){
      return MessageBox.confirm('无访问权限，请联系商务！', '提示', {})
    }
    if(item.child&&item.child.length){
      item  = item.child[0];
    }
    let nav_type = item.nav_type||0
    let url;
    switch (nav_type) {
      case 0:
        this.navTo('/index')
        break;
      case 1:
        url = item.version=='2' ? '/special' : '/selection';
        this.navTo(url, {
          nav_type,
          id: item.nav_id
        }, false, false)
        break;
      case 2:
        //活动专题页
        url = item.version=='2' ? '/special' : '/topic';
        this.navTo(url, {
          nav_type,
          id: item.nav_id
        }, false, false)
        break
      case 4:
        this.navTo('/topic', {
          nav_type,
          id: item.nav_id
        }, false, false)
        break;
      case 6:
        if(this.checkLogin()){
          this.navTo('/local', {
            nav_type,
            id: item.nav_id
          }, true, false)
        }
        break;
      case 5:
        if(this.checkLogin()){
          this.navTo('/filmclient',{},true)
        }
        break;
      case 7:
        this.navTo('/panicBuy',{},true)
        break;
      case 8:
        this.navTo('/hotel',{},true)
        break;
      default:
        MessageBox.warning('开发中');
    }
}